import React, { useMemo, useState } from "react"
import { typeNumber } from "../../../utilities/Addons"
import { getPersonneType, PERSONNE_APPELLATION } from "./Personne"
import { useSelector } from "react-redux"
import { useTarif } from "../../../hooks/useTarif"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfo, faSearchDollar } from "@fortawesome/free-solid-svg-icons"

const Entite = ({
	editEntite,
	updateEntite = null,
	saveEntite = null,
	types = ENTITE_TYPES.map((el) => el),
	showExtraDataBtn = false,
	selectTypeDisabled = false,
	showType = true,
	showLabel = true,
	showTel = true,
	showEmail = true,
	updateEntiteFull = null,
}) => {
	const [showExtraData, setShowExtraData] = useState(false)
	const { groups } = useSelector((state) => state.navInfo.login)
	const { prixHoraire, prixHoraireSociete, prixHoraireAssurance } =
		useTarif()
	const getPrixHoraire = () => {
		if (editEntite.type === ENTITE_TYPE_SOCIETE)
			return prixHoraireSociete
		else if (editEntite.type === ENTITE_TYPE_ASSURANCE)
			return prixHoraireAssurance
		else if (editEntite.type === ENTITE_TYPE_PERSONNE_PHYSIQUE)
			return prixHoraire
		return ""
	}
	const updateExtraData = (key, value) => {
		let tempExtraData = Object.assign({}, editEntite.extra_data)
		tempExtraData[key] = value
		updateEntite("extra_data", tempExtraData)
	}
	const changeEntiteType = (type) => {
		updateEntite("type", type)
	}
	const toggleExtraData = () => {
		const base_extra_datas = {
			telephone2: "",
			email2: "",
			remarques: "",
		}
		let extra_datas = Object.assign({}, editEntite.extra_data)
		for (let [k, v] of Object.entries(base_extra_datas)) {
			if (!editEntite.extra_data.hasOwnProperty(k)) {
				extra_datas[k] = v
			}
		}
		setShowExtraData((prevState) => !prevState)
	}
	const toggleMauvaisPayeur = () => {
		if (updateEntiteFull === null) return
		let tempEntite = Object.assign({}, editEntite)
		if (editEntite.is_mauvais_payeur) {
			tempEntite.is_mauvais_payeur = false
		} else {
			tempEntite.is_mauvais_payeur = true
			tempEntite.can_payer_par_facture = false
		}
		updateEntiteFull(tempEntite)
	}
	const isEntiteSocieteOuAssurance = useMemo(() => {
		return [ENTITE_TYPE_ASSURANCE, ENTITE_TYPE_SOCIETE].includes(
			editEntite.type,
		)
	}, [editEntite.type])
	const isEntiteSocieteOuAssuranceOuPersonne = useMemo(() => {
		return [
			ENTITE_TYPE_ASSURANCE,
			ENTITE_TYPE_SOCIETE,
			ENTITE_TYPE_PERSONNE_PHYSIQUE,
		].includes(editEntite.type)
	}, [editEntite.type])
	return (
		<>
			{showType && (
				<div className="lab-in lab-in-extra border-box rel">
					{showExtraDataBtn && (
						<button
							className={"norm-btn"}
							onClick={toggleExtraData}
							style={{ position: "absolute", top: -5, right: 0 }}
						>
							<FontAwesomeIcon icon={faInfo} />
						</button>
					)}
					<label>Type</label>
					<select
						value={editEntite.type}
						onChange={(e) =>
							changeEntiteType(parseInt(e.target.value))
						}
						disabled={updateEntite === null || selectTypeDisabled}
					>
						{types.map((el, index) => (
							<option key={`option_${index}`} value={el[0]}>
								{el[1]}
							</option>
						))}
					</select>
				</div>
			)}
			{showLabel &&
				(editEntite.type !== ENTITE_TYPE_PERSONNE_PHYSIQUE ? (
					<div className="lab-in lab-in-extra border-box relative">
						{editEntite.type === ENTITE_TYPE_SOCIETE &&
							editEntite.is_mauvais_payeur && (
								<FontAwesomeIcon
									icon={faSearchDollar}
									className={"float-right red1"}
								/>
							)}
						<label>Label</label>
						<input
							value={editEntite.label}
							onChange={(e) =>
								updateEntite("label", e.target.value)
							}
							disabled={updateEntite === null}
						/>
					</div>
				) : (
					<>
						<div className="lab-in lab-in-extra border-box relative">
							{editEntite.is_mauvais_payeur && (
								<FontAwesomeIcon
									icon={faSearchDollar}
									className={"float-right red1"}
								/>
							)}
							<label>Appellation</label>
							<select
								value={editEntite.appellation}
								onChange={(e) =>
									updateEntite(
										"appellation",
										parseInt(e.target.value),
									)
								}
								disabled={updateEntite === null}
							>
								{PERSONNE_APPELLATION.map((app_type) => (
									<option
										key={`select_app_type_${app_type[0]}`}
										value={app_type[0]}
									>
										{app_type[1]}
									</option>
								))}
							</select>
						</div>
						<div className="lab-in lab-in-extra border-box">
							<label>Nom</label>
							<input
								value={editEntite.nom}
								onChange={(e) =>
									updateEntite("nom", e.target.value)
								}
								disabled={updateEntite === null}
							/>
						</div>
						<div className="lab-in lab-in-extra border-box">
							<label>Prénom</label>
							<input
								value={editEntite.prenom}
								onChange={(e) =>
									updateEntite("prenom", e.target.value)
								}
								disabled={updateEntite === null}
							/>
						</div>
						<div className="lab-in lab-in-extra border-box">
							<label>Date de Naissance</label>
							<input
								type={"date"}
								value={editEntite.date_naissance}
								onChange={(e) =>
									updateEntite(
										"date_naissance",
										e.target.value,
									)
								}
								disabled={updateEntite === null}
							/>
						</div>
					</>
				))}
			{showTel && (
				<div className="lab-in lab-in-extra border-box">
					<label>Téléphone</label>
					<input
						value={editEntite.telephone}
						onChange={(e) =>
							updateEntite("telephone", e.target.value)
						}
						disabled={updateEntite === null}
					/>
				</div>
			)}
			{showExtraData && (
				<div className="lab-in lab-in-extra border-box">
					<label>Téléphone Supplémentaire</label>
					<input
						value={editEntite.extra_data.telephone2}
						onChange={(e) =>
							updateExtraData("telephone2", e.target.value)
						}
						disabled={updateEntite === null}
					/>
				</div>
			)}
			{showEmail && (
				<div className="lab-in lab-in-extra border-box">
					<label>E-mail</label>
					<input
						value={editEntite.email}
						onChange={(e) => updateEntite("email", e.target.value)}
						disabled={updateEntite === null}
					/>
				</div>
			)}
			{showExtraData && (
				<>
					<div className="lab-in lab-in-extra border-box">
						<label>E-mail Supplémentaire</label>
						<input
							value={editEntite.extra_data.email2}
							onChange={(e) =>
								updateExtraData("email2", e.target.value)
							}
							disabled={updateEntite === null}
						/>
					</div>
					<div className="lab-in lab-in-extra border-box">
						<label>Remarques</label>
						<textarea
							cols={5}
							value={editEntite.extra_data.remarques}
							onChange={(e) =>
								updateExtraData("remarques", e.target.value)
							}
							disabled={updateEntite === null}
						/>
					</div>
				</>
			)}
			<div className="row full">
				{isEntiteSocieteOuAssuranceOuPersonne &&
					updateEntite !== null &&
					groups.includes("boss") && (
						<>
							<div className="lab-in border-box small">
								<label>Prix vente main d'oeuvre</label>
								<input
									value={getPrixHoraire()}
									readOnly={true}
								/>
							</div>
							<div className="lab-in border-box small">
								<label>Rabais vente main d'oeuvre</label>
								<input
									value={
										editEntite.extra_data
											.prix_vente_unitaire_mo
									}
									onChange={(e) =>
										updateExtraData(
											"prix_vente_unitaire_mo",
											e.target.value,
										)
									}
									onKeyDown={(e) => typeNumber(e)}
									disabled={updateEntite === null}
								/>
							</div>
						</>
					)}
				{isEntiteSocieteOuAssuranceOuPersonne &&
					updateEntite !== null && (
						<>
							<div className="lab-in border-box small">
								<label>Mauvais payeur</label>
								<input
									type={"checkbox"}
									className="m-auto big hover"
									checked={editEntite.is_mauvais_payeur}
									onChange={toggleMauvaisPayeur}
									disabled={updateEntite === null}
								/>
							</div>
							<div className="lab-in border-box small">
								<label>Payable facture</label>
								<input
									type={"checkbox"}
									className="m-auto big hover"
									checked={editEntite.can_payer_par_facture}
									onChange={(_) =>
										updateEntite(
											"can_payer_par_facture",
											!editEntite.can_payer_par_facture,
										)
									}
									disabled={
										updateEntite === null ||
										editEntite.is_mauvais_payeur
									}
								/>
							</div>
						</>
					)}
				{editEntite.type === ENTITE_TYPE_SOUS_TRAITANT &&
					updateEntite !== null && (
						<div className="lab-in border-box small">
							<label>Prix achat main d'oeuvre</label>
							<input
								value={
									editEntite.extra_data.prix_achat_unitaire_mo
								}
								onChange={(e) =>
									updateExtraData(
										"prix_achat_unitaire_mo",
										e.target.value,
									)
								}
								onKeyDown={(e) => typeNumber(e)}
								disabled={updateEntite === null}
							/>
						</div>
					)}
			</div>
			{saveEntite && (
				<button
					type={"button"}
					className={"norm-btn2 mt-20"}
					onClick={saveEntite}
				>
					Sauvegarder
				</button>
			)}
		</>
	)
}

export default Entite

export const ENTITE_TYPE_SOCIETE = 0
export const ENTITE_TYPE_ASSURANCE = 1
export const ENTITE_TYPE_POLICE = 2
export const ENTITE_TYPE_SOUS_TRAITANT = 3
// export const ENTITE_TYPE_PRIVE = 4
export const ENTITE_TYPE_PERSONNE_PHYSIQUE = 5
export const ENTITE_TYPE_GARAGE = 6
export const ENTITE_TYPE_BUREAU_EXPERT = 7
export const ENTITE_TYPE_ASSISTANCE = 8
export const ENTITE_TYPE_MASTER = 20
export const ENTITE_TYPE_CLIENT_PASSAGE = 21

export const ENTITE_TYPES_ATELIER = [
	[ENTITE_TYPE_SOCIETE, "Société"],
	[ENTITE_TYPE_PERSONNE_PHYSIQUE, "Personne physique"],
	[ENTITE_TYPE_MASTER, "Garage SVP"],
	[ENTITE_TYPE_CLIENT_PASSAGE, "Client de passage"],
]

export const ENTITE_TYPES = [
	[ENTITE_TYPE_SOCIETE, "Société"],
	[ENTITE_TYPE_ASSURANCE, "Assurance"],
	[ENTITE_TYPE_POLICE, "Poste de Police"],
	[ENTITE_TYPE_SOUS_TRAITANT, "Sous-traitant"],
	// [ENTITE_TYPE_PRIVE, "Privé"],
	[ENTITE_TYPE_PERSONNE_PHYSIQUE, "Personne physique"],
	[ENTITE_TYPE_GARAGE, "Garage"],
	[ENTITE_TYPE_BUREAU_EXPERT, "Bureau d'experts"],
	[ENTITE_TYPE_ASSISTANCE, "Assistance"],
	[ENTITE_TYPE_MASTER, "Garage SVP"],
]

export const ENTITE_TYPES_DICT = Object.fromEntries(ENTITE_TYPES)
